import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Define a type for the slice state

// Define the initial state using that type

const leaveAppliedSlice = createSlice({
  name: 'leaveApplied',

  initialState: {
    leaveApplied: [],
    refreshLeaveApplied: false,
    refetch: false,
  },
  reducers: {
    setAllLeaveApplied: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.leaveApplied = payload;
    },
    setRefreshLeaveApplied: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.refreshLeaveApplied = payload;
    },
    setRefetch: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.refetch = payload;
    },
    resetAllLeaveApplied: (state) => {
      state.leaveApplied = [];
    },
  },
});

export const {
  setAllLeaveApplied,
  resetAllLeaveApplied,
  setRefreshLeaveApplied,
  setRefetch,
} = leaveAppliedSlice.actions;

export default leaveAppliedSlice.reducer;
